import { useState, useEffect } from 'react';
import { getStats } from '../../services/reports';
import StatCard from '../../components/Cards/StatCard';
import BarChart from '../../components/Charts/BarChart';

const UnitAdminDashboard = () => {
  const [stats, setStats] = useState({
    totalMembers: 0,
    activeCases: 0,
    totalContributions: 0,
    pendingApprovals: 0,
  });
  const [monthlyData, setMonthlyData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      // Fetch unit-specific stats (backend should filter by user's assigned units)
      const data = await getStats({ scope: 'unit' });
      setStats(data);
      setMonthlyData(data.monthlyContributions || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1>Unit Dashboard</h1>
      <div style={{ display: 'flex', gap: '1rem', marginBottom: '2rem' }}>
        <StatCard title="Members" value={stats.totalMembers} />
        <StatCard title="Active Cases" value={stats.activeCases} />
        <StatCard title="Contributions (KSh)" value={stats.totalContributions.toLocaleString()} />
        <StatCard title="Pending Approvals" value={stats.pendingApprovals} />
      </div>
      <h2>Monthly Contributions (This Unit)</h2>
      <BarChart data={monthlyData} xKey="month" barKeys={['amount']} />
    </div>
  );
};

export default UnitAdminDashboard;